import { AccessRuleMultiEntitlementContext } from "../models";
import { AccessNode } from "../../models";
import {
  BaseAccessRuleRequestParams,
  mapNodeTypeToScopeCategory,
} from "./accessRuleRequestMapper";
import { buildMultiAddAccessRuleRequest } from "./accessRuleRequestBuilder";
import { extractId } from "../../module";

export type MapAccessRuleMultiAddRequestParams = BaseAccessRuleRequestParams & {
  entitlementTypeIds: number[];
  fulfillmentSeasonId: number;
  accessNodes: AccessNode[];
};

// Assumes validation has already been done and all required fields are present and valid
export function mapAccessRuleMultiAddRequest(
  params: MapAccessRuleMultiAddRequestParams,
) {
  const {
    userId,
    operatorId,
    entitlementTypeIds,
    fulfillmentSeasonId,
    accessNodes,
    changeSet,
  } = params;

  const contexts = buildContexts(
    accessNodes,
    entitlementTypeIds,
    fulfillmentSeasonId,
  );

  return buildMultiAddAccessRuleRequest({
    userId,
    operatorId,
    contexts,
    changeSet,
  });
}

function buildContexts(
  accessNodes: AccessNode[],
  entitlementTypeIds: number[],
  fulfillmentSeasonId: number,
): AccessRuleMultiEntitlementContext[] {
  return accessNodes.flatMap((accessNode) => {
    const entityId = extractId(accessNode.id);

    if (entityId === undefined) return [];

    const scopeCategory = mapNodeTypeToScopeCategory(accessNode.type);

    return {
      EntitlementTypeIds: entitlementTypeIds,
      FulfillmentSeasonId: fulfillmentSeasonId,
      LiftAccessRuleScopeCategory: scopeCategory,
      LiftAccessRuleScopeEntityId: entityId,
    };
  });
}
